export default "__VITE_ASSET__CCx9gDzQ__"